import { IProductGeneralInfo } from '../dataModels/IProductGeneralInfo';
import * as style from './style.css';
import ShopIcon from '../../../assets/icons/ShopIcon';
import { Action } from '../../../framework/framework/components/Types';
import React = require('react');

interface IProps {
    info: IProductGeneralInfo;
    basketAction: Action;
}

interface IState {

}

export default class ProductContextMenu extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {

        };
    }

    render() {
        const price = this.props.info.promoPrice || this.props.info.price;
        return (
            <div className={style.contextMenu}>
                <div className={style.name}>
                    {this.props.info.name}
                </div>
                <div>
                    {this.props.info.promoPrice && <div className={style.oldPrice}>
                        {this.props.info.price.toFixed(2)}
                    </div>}
                    {price.toFixed(2)} zł

                </div>
                <div className={style.icon}>

                    +<ShopIcon onClick={() => this.props.basketAction()}/>
                </div>
            </div>
        );
    }
}
